// extracted by mini-css-extract-plugin
module.exports = {"line-clamp-3":"style_line-clamp-3__U_Tjj"};